import { useAppSelector } from "../../store/hooks";
import { useGetQuery } from "../../store/slices/apiSlice";
import { StimJob } from "../../store/types";

interface StimJobsApiProps {
  wellUid?: string | null;
  wellboreUid?: string | null;
  skip?: boolean;
}

export const useStimJobsAPI = ({
  wellUid,
  wellboreUid,
  skip = false,
}: StimJobsApiProps) => {
  const stimJobsEP = useAppSelector((state) => state.endpoints.stimJobs);
  const wellsEP = useAppSelector((state) => state.endpoints.wells);
  const wellboresEP = useAppSelector((state) => state.endpoints.wellbores);

  const hasBase = Boolean(
    wellsEP && wellUid && wellboresEP && wellboreUid && stimJobsEP
  );
  const url = hasBase
    ? `${wellsEP}/${wellUid}${wellboresEP}/${wellboreUid}${stimJobsEP}`
    : "";

  const { data, isLoading, error, refetch } = useGetQuery(url, {
    skip: !hasBase || skip,
    refetchOnMountOrArgChange: true,
  });

  // A wellbore has a single stim-job, so the collection endpoint is queried
  // without a uid and the first (only) element is used.
  const stimJob = Array.isArray(data)
    ? (data[0] as StimJob | undefined)
    : (data as StimJob | undefined);

  return { stimJobsEP, stimJob, isLoading, error, refetch };
};
